export default {
  weights: {
    light: 300,
    normal: 400,
    medium: 500,
    bold: 600,
    'extra-bold': 700,
  },
  sizes: {
    xxsmall: '10px',
    xsmall: '12px',
    small: '14px',
    medium: '16px',
    large: '18px',
    xlarge: '20px',
    xxlarge: '24px',
    xxxlarge: '34px',
    huge: '52px',
  },
} as const;
